import { useEffect, useState } from "react";
import { resolveEnvelope, widgetEnvelopes } from "../../streaming/widgetEnvelopes";

/**
 * The envelope a record renders (spec-widget-mcp 05 Step 7): its persisted `reply.widget` patched in
 * place by whatever `record_update_stream.widget` arrived for it live. Never adds a record.
 * @param {string} recordId
 * @param {object|undefined} persisted `reply.widget`
 * @param {import('../../streaming/widgetEnvelopes').WidgetEnvelopeStore} [store]
 * @returns {object|null}
 */
export function useLiveWidgetEnvelope(recordId, persisted, store = widgetEnvelopes) {
	const [live, setLive] = useState(() => (recordId ? store.envelope(recordId) : null));
	useEffect(() => {
		if (!recordId) return undefined;
		setLive(store.envelope(recordId));
		return store.subscribe((id) => {
			if (id === recordId) setLive(store.envelope(recordId));
		});
	}, [recordId, store]);
	return resolveEnvelope(persisted, live);
}
